import axios  from "axios"

export default {
    async addInsemiInfo(data) {
        return await axios.post('inseminator-statistic', data)
            .then(result => result.data)
            .catch( error => Promise.reject(error));
    },
    async getInseminatorInfo(dataOptions,search) {
        var url = `inseminator-statistic?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
            if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getSingleInseminator(id) {
        var url = `inseminator-statistic/${id}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async updateInsemi(data) {
        var url = `inseminator-statistic`
        return await axios.put(url, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error))
    },
}